module.exports = __webpack_public_path__ + "media/images/area/feature/banner/en/pc/en_tohoku-ca296c99c1887f4e9b2767654f75b149.png";